import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';

Vue.use(Vuex);

const productNames = {
    semibookclub: 'E-learning',
    socsolutions: 'SoC & Solutions'
};

// 所擁有的狀態
const status = {
    home : 0,
    info : 1,
    edit : 2,
    classify: 3,
    memberlist: 4,
    pdfView: 5,
    videoView: 6,
    account: 7,
    profile: 8,
    editAccount: 9,
    department: 10,
    setting: 11,
    trend: 12,
    report: 13,
    course: 14,
    regApproval: 15,
    favorite: 16,
    hasIcivicLogin: 17,
};

// 所擁有的提示訊息顯示狀態
const hintStatus = {
    home : false,
    table: false,
    info : false,
    edit : false,
    classify: false,
    memberlist: false,
    pdfView: false,
    videoView: false,
    comment: false,
    profile: false,
    editAccount: false,
    department: false,
    setting: false,
    trend: false,
};

// 資源相關參數
const resourceList = {
    //資源列表每頁數量
    count: 10,
    //資源列表total數量
    total: 0,
    //資源列表目前頁數
    currentPage: 1,
    //資源列表offset
    offset: 0,
    //學院ID
    categoryGroupId: null,
    //資源主題分類ID
    categoryId: null,
    //資源真實部門
    actual_depid: null,
    //資源Level
    level: null,
    //資源type
    type: null,
    //資源secret
    secret: null,
    //資源startTime
    startTime: null,
    //資源endTime
    endTime: null,
    //資源order
    order: null,
    //資源keyword
    keyword: '',
    //資源by
    by: null,
    //資源作者
    author: null,
    //資源作者名稱
    authorName: null,
    //資源評分
    rate: null
};

// Edit資源相關參數
const editResource = {
    title: '',
    description: '',
    categoryId: null,
    depId: null, 
    actual_depid: null,
    level: 1,
    secret: 0,
    keywords: [],
    fileIds:[],
    author: '',
    myComment: {
        id: null,
        rating: 0,
        content: '',
        anonymous: 0
    },
    reply: ''
};

// 所擁有的帳號狀態
const accountStatus = {
    list : 0,
    delete : 1,
    add : 2,
    edit: 3,
    keep: 4,
};

// 所擁有的部門狀態
const departmentStatus = {
    list : 0,
    delete : 1,
    add : 2,
};

// 所擁有的帳號狀態
const accountList = {
    //帳號清單狀態切換
    status : accountStatus.list,
    selectedDepId: null,
    pageCount: 10,
    offset: 0,
    currentPage: 1,
    order: null,
    keyword: '',
    by: null,
};

// 所擁有的分類狀態
const categoryStatus = {
    list : 0,
    delete : 1,
    add : 2,
};

// 所擁有的會員清單分類狀態
const memberListStatus = {
    list : 0,
    delete : 1,
    add : 2,
};

// Edit會員相關參數
const editAccount = {
    displayName: '',
    name: null,
    password: '',
    checkPassword: '',
    depId: null, 
    actual_depid: null,
    email: '',
    level: 1,
    isManager: 0,
    status: 0,
    included: 1,
    not_included_date: 0,
};


// 課程相關參數
const courseListStatus = {
    type: null,
    depid: null,
    actual_depid: null,
    order: null,
    by: null,
    currentPage: 1,
    offset: 0,
    pageSize: 10,
    total: 0,
};

const course = {
    keyword: '',
    listStatus: courseListStatus,
};

// 我的最愛參數
const favoriteListStatus = {
    order: null,
    by: null,
    currentPage: 1,
    offset: 0,
    pageSize: 10,
    total: 0,
};

const favorite = {
    listStatus: favoriteListStatus,
}

// 統計報表參數
const detailListStatus = {
    pagination: {
        current_page: 1,
        offset: 0,
        page_size:10,
    },
};

const personalListStatus = {
    id: null,
    name: null,
    pagination: {
        current_page: 1,
        offset: 0,
        page_size:10,
    },
};

const report = {
    selectedDepId: null,
    dateRange: null,
    isShowPersonalDetail: false,
    personalListStatus: personalListStatus,
    detailListStatus: detailListStatus,
};

// 初始設定
const state = {
    // 分片大小
    fileChunkSize: 1024*1024*10,
    //儲存切割檔案的陣列
    sliceDataInfo: {},
    productNames: productNames,
    userInfoReady: false,
    categoryGroupReady: false,
    userName: '',
    userDepId: null,
    userActualDepId: null,
    infoDepId: null,
    infoActualDepId: null,
    //熱門主題頁面的分類設定
    checkedCategoryListForTrend: [],
    //是否開啟進階篩選
    isShowCheckFilter: false,
    //進階篩選選取哪些 filters
    checkedFilterLists: [],
    //是否存在搜尋字串
    isHaveSearchKeyword: false,
    //是否為後台管理模式
    isBackendMode: false,
    //是否為系統管理者(true: 系統管理者 / false: 部門管理者)
    isSystemAdminMode: false,
    //狀態切換
    nowStatus : status.home,
    //分類狀態切換
    nowDepartmentStatus : departmentStatus.list,
    //分類狀態切換
    nowCategoryStatus : categoryStatus.list,
    //會員清單狀態切換
    nowMemberListStatus : memberListStatus.list,
    //資源相關參數
    resourceList : resourceList,
    //資源相關參數
    accountList : accountList,
    //資源列表真實部門相關參數
    actualDeps:[],
    actualDepsOptions:[],
    times:[{id: 0, title: "今日"}, {id: 1, title: "最近 7 天"}, {id: 2, title: "最近 30 天"}, {id: 3, title: "最近一年"}],
    //資源filter參數
    checkedDeps: null,
    checkedLevels: [],
    checkedTypes: [],
    checkedTimes: null,
    checkedSecrets: [],
    //要編輯的資源編輯的麵包屑
    editResourceBreadcrumbs:[],
    //要編輯的資源ID
    editResourceId: [],
    //要編輯的編輯的資源附件
    editResourceFileAttrs:[],
    tempEditResourceFileAttrsIds:[],
    //Edit資源相關參數
    editResource: editResource,
    //是否可以儲存
    isCheckSave: true,
    //按鈕操作是否在運行中
    isBtnProcessing: false,
    isCancelBtnDisabled: false,
    //秀出提示訊息
    showHint: false,
    hintStatus: hintStatus,
    //fadeout
    fadeOutTime: 5000,
    pdfLoading: false,
    pdfDataLoad: false,
    pdfError: false,
    //Edit會員相關參數
    editAccount: editAccount,
    openTime: 0,
    closeTime: 0,
    //category資料是否有被修改過
    isCategoryUpdated: false,
    course: course,
    favorite: favorite,
    report: report,
    entrance: null,
    regDot: false,
};  
// 定义所需的 mutations
/*
const mutations = {
    INCREMENT(state) {
        state.count++;
    },
    DECREMENT(state) {
        state.count--;
    }
}
*/
const mutations = {
    SET_HAS_ICIVIC_LOGIN(state, token) {
        state.hasIcivicLogin = token
        localStorage.setItem('has_icivic_login', token)
    },
};

export default new Vuex.Store({
    actions: {
        setHasIcivicLogin({ commit }, token) {
            commit('SET_HAS_ICIVIC_LOGIN', token)
          },
    },
    getters,
    state,
    mutations,
});


// WEBPACK FOOTER //
// ./src/vuex/store.js